/**
 * 侧滑和弹窗组件公共方法
 * 解决侧滑初始渲染闪烁问题
 * 侧滑关闭时都会执行close和closed方法
 */
import { ref, watch, onMounted, nextTick, provide } from 'vue'
import { ROUTERJUMPUNMOUNTCOMPONENT } from '../tokens/router-provider'
export function useDrawerPack(visible, emit, checkModifyFlag) {
  const showDrawer = ref(false)
  watch(visible, () => (showDrawer.value = visible.value))
  onMounted(() => {
    if (visible.value) {
      nextTick(() => {
        showDrawer.value = true
      })
    }
  })

  const closeDrawer = () => {
    showDrawer.value = false
  }

  const onCancel = async (done) => {
    const modifyFlag = await checkModifyFlag?.()
    if (modifyFlag) {
      return
    }
    emit('on-cancel')
    if (typeof done == 'function') done()
  }
  //手动关闭
  const handleCancel = () => {
    onCancel(() => closeDrawer())
  }
  const close = () => {
    emit('update:visible', false)
    emit('close', false)
    showDrawer.value = false
  }

  const closed = () => {
    emit('closed')
  }

  provide(ROUTERJUMPUNMOUNTCOMPONENT, {
    closeDrawer: handleCancel,
  })

  return {
    showDrawer,
    close,
    closed,
    closeDrawer,
    onCancel,
    handleCancel,
  }
}
